import React, { useRef, useEffect, useState } from "react";
import FlowerRain from "./FlowerRain";
import GemsRain from "./GemsRain";
import Bell from "./Bell";
import AartiThali from "./AartiThali";
import { fetchImage } from "../../../utility/commonDownloadS3Image";

const GlitterTrail = ({
  isAarti,
  isFlowerRain,
  isGems,
  isBellAnimating,
  mainIdols,
}) => {
  const [imageUrl, setImageUrl] = useState(null);
  const canvasRef = useRef(null);
  const imageRef = useRef(null);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (mainIdols && mainIdols.length > 0) {
      const loadImages = async () => {
        const urls = await Promise.all(
          mainIdols.map(async (item) => {
            const url = await fetchImage(item.image);
            return url;
          })
        );
        setImageUrl(urls);
      };

      loadImages();
    }
  }, [mainIdols]);
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    const particles = [];
    const starShapes = [
      { char: "\u2605", baseSize: 12 }, // ★
      { char: "\u272D", baseSize: 11 }, // ✭
      { char: "\u2736", baseSize: 10 }, // ✶
      { char: "\u2747", baseSize: 12 }, // ❇
      { char: "\u273F", baseSize: 8 }, // ✿
      { char: "\u25EF", baseSize: 10 }, // ◯
      { char: "\u25CC", baseSize: 8 }, // ◌
      { char: "\u2744", baseSize: 10, rotatable: true }, // ❄
      { char: "\u2745", baseSize: 10, rotatable: true }, // ❅
      { char: "\u2746", baseSize: 9, rotatable: true }, // ❆
      { char: ".", baseSize: 6, isDot: true }, // ✨ gold dust
    ];

    let sAngle = 0;
    let sDirection = 1;
    let pathPhase = "s";
    let circleAngle = 0;
    const circleRadius = 200; // 💡 Increased for bigger circular motion
    const circleCenter = { x: 0, y: 0 };

    function createExplosion(x, y) {
      const count = 30 + Math.floor(Math.random() * 20);
      for (let i = 0; i < count; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = Math.random() * 3 + 1;
        const shape = starShapes[Math.floor(Math.random() * starShapes.length)];
        const sizeVariation = Math.random() * 1.5 + 0.5;
        particles.push({
          x,
          y,
          dx: Math.cos(angle) * speed,
          dy: Math.sin(angle) * speed,
          opacity: Math.random() * 0.6 + 0.4,
          size: shape.baseSize * sizeVariation,
          char: shape.char,
          life: 100,
        });
      }
    }

    function createSPathTrail() {
      const amplitude = canvas.height / 4;
      const frequency = (2 * Math.PI) / canvas.width;
      const x = sAngle % canvas.width;
      const y = canvas.height / 2 + amplitude * Math.sin(frequency * x);
      const shape = starShapes[Math.floor(Math.random() * starShapes.length)];
      const sizeVariation = Math.random() * 1.5 + 0.5;

      particles.push({
        x,
        y,
        dx: Math.random() * 1 - 0.5, // 🔄 drift in random X
        dy: Math.random() * 1 - 0.5, // 🔄 drift in random Y
        opacity: Math.random() * 0.6 + 0.4,
        size: shape.baseSize * sizeVariation,
        char: shape.char,
        life: 100,
      });

      sAngle += 2 * sDirection;
      if (sAngle >= canvas.width || sAngle <= 0) {
        sDirection *= -1;
        pathPhase = "circle";
        circleCenter.x = canvas.width / 2;
        circleCenter.y = canvas.height / 2;
        circleAngle = 0;
      }
    }

    function createCirclePathTrail() {
      const angle = circleAngle;
      const x = circleCenter.x + circleRadius * Math.cos(angle);
      const y = circleCenter.y + circleRadius * Math.sin(angle);
      const shape = starShapes[Math.floor(Math.random() * starShapes.length)];
      const sizeVariation = Math.random() * 1.5 + 0.5;

      particles.push({
        x,
        y,
        dx: Math.random() * 1 - 0.5, // 🔄 sparkle trails drift away
        dy: Math.random() * 1 - 0.5,
        opacity: Math.random() * 0.6 + 0.4,
        size: shape.baseSize * sizeVariation,
        char: shape.char,
        life: 100,
      });

      circleAngle += 0.05;
      if (circleAngle >= Math.PI * 2) {
        pathPhase = "s";
      }
    }

    setInterval(() => {
      const x = Math.random() * canvas.width;
      const y = Math.random() * canvas.height;
      // createExplosion(x, y);
    }, 1000);

    function animate() {
      //   ctx.fillStyle = "rgba(0, 0, 0, 0.15)";
      //   ctx.fillRect(0, 0, canvas.width, canvas.height);
      const bgGradient = ctx.createLinearGradient(
        0,
        0,
        canvas.width,
        canvas.height
      );
      bgGradient.addColorStop(0, "#fdf6ec"); // soft cream
      bgGradient.addColorStop(1, "#f5e8ca"); // light warm tone
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // if (pathPhase === "s") {
      //   createSPathTrail();
      // } else {
      //   createCirclePathTrail();
      // }

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.x += p.dx || 0;
        p.y += p.dy || 0;

        ctx.font = `${p.size}px serif`;

        const gradient = ctx.createLinearGradient(p.x, p.y, p.x + p.size, p.y);
        gradient.addColorStop(0, `rgba(70, 37, 35, ${p.opacity})`);
        gradient.addColorStop(0.22, `rgba(203, 155, 81, ${p.opacity})`);
        gradient.addColorStop(0.45, `rgba(246, 226, 122, ${p.opacity})`);
        gradient.addColorStop(0.5, `rgba(246, 242, 192, ${p.opacity})`);
        gradient.addColorStop(0.55, `rgba(246, 226, 122, ${p.opacity})`);
        gradient.addColorStop(0.78, `rgba(203, 155, 81, ${p.opacity})`);
        gradient.addColorStop(1, `rgba(70, 37, 35, ${p.opacity})`);

        ctx.fillStyle = gradient;
        ctx.fillText(p.char, p.x, p.y);

        p.opacity -= 0.01;
        p.life--;
        if (p.life <= 0 || p.opacity <= 0) particles.splice(i, 1);
      }
      if (imageRef.current) {
        const img = imageRef.current;

        // Scale image to 80% of canvas width
        const maxImageWidth = canvas.width * 0.35;
        const scale = maxImageWidth / img.naturalWidth;

        const imgWidth = img.naturalWidth * scale;
        const imgHeight = img.naturalHeight * scale;

        const centerX = (canvas.width - imgWidth) / 2;
        const centerY = canvas.height * 0; // 5% from the top for padding

        ctx.drawImage(img, centerX, centerY, imgWidth, imgHeight);
      }
      requestAnimationFrame(animate);
    }

    animate();

    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return (
    <>
      <canvas ref={canvasRef} style={{ width: "100% !important" }} />

      {/* Preload Image */}
      {imageUrl && (
        <img
          ref={imageRef}
          src={imageUrl}
          alt="Main Idol"
          style={{ display: "none" }}
        />
      )}

      {/* Overlapping Components */}
      {window.innerWidth <= 768 && isBellAnimating && (
        <div className="fixed top-0 left-0 w-full h-full z-10">
          <Bell position="left" />
          <Bell position="right" />
        </div>
      )}

      {isAarti && (
        <div className="fixed top-0 left-0 w-full h-full z-10">
          <AartiThali animate={isAarti} />
        </div>
      )}
      {isFlowerRain && <FlowerRain />}
      {isGems && <GemsRain />}
    </>
  );
};

export default GlitterTrail;
